// Dr. Paws conversion draft: disable the legacy cart drawer fetch monkeypatch.
// This prevents failed add-to-cart requests from opening an empty drawer.
window.dpCartDrawerPageRefreshPatch = true;
window.dpCartDrawerFetchPatch = true;

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
